import { motion } from 'framer-motion'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

const StImage = styled.div<{ imgSrc: string }>`
  ${({ imgSrc }) => `
    width: 100%;
    height: 100%;
    background: url(${imgSrc}) center no-repeat;
    background-size: cover;
    overflow: hidden;
    min-height: 250px;
    border-radius: 0 0 80px 0;
    @media ${breakpoints.fromS} {
      border-radius: 0;
      min-width: 50%;
      width: 50%;
    }
  `}
`

const StContentContainer = styled.div`
  position: relative;
  grid-area: content;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  @media ${breakpoints.fromS} {
    flex-direction: row-reverse;
  }
`

const StContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space8};
    gap: ${theme.UI.SpacingPx.Space4};
  `}

  margin-top: ${({ theme }) => theme.UI.SpacingPx.Space8};

  @media ${breakpoints.fromS} {
    justify-content: center;
  }
`

const StButtonContainer = styled.div`
  box-shadow: 0px -1px 20px rgba(4, 24, 49, 0.07);

  ${({ theme }) => `
    padding: ${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space6};
    padding-bottom: calc(${theme.UI.SpacingPx.Space2} + max(var(--safe-area-inset-bottom), 20px));
  `} @media ${breakpoints.fromS} {
    ${({ theme }) => `
      /* Sits inside StContent on web, which already provides the horizontal
         padding — only add top spacing so the buttons align with the heading
         and body instead of being indented by a second padding. */
      padding: ${theme.UI.SpacingPx.Space8} 0 0;
    `}
    box-shadow: none;
    width: 100%;
  }
`

const StBackButton = styled.button`
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};

  > svg + span {
    margin-left: ${({ theme }) => theme.UI.SpacingPx.Space2};
  }

  > span + svg {
    margin-left: ${({ theme }) => theme.UI.SpacingPx.Space2};
  }
`

const StAnimatedBackButton = motion(StBackButton)

export { StAnimatedBackButton, StButtonContainer, StContainer, StContent, StContentContainer, StImage }
